export default "__VITE_ASSET__DdDRh5Kf__"